import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import es from '@/locales/es.json'
import fr from '@/locales/fr.json'

export type SupportedLocale = 'en' | 'es' | 'fr'

const savedLocale = localStorage.getItem('locale') as SupportedLocale | null
const browserLocale = navigator.language.split('-')[0] as SupportedLocale
const defaultLocale = import.meta.env.VITE_DEFAULT_LOCALE || 'en'

// Determine initial locale
const getInitialLocale = (): SupportedLocale => {
  if (savedLocale && ['en', 'es', 'fr'].includes(savedLocale)) {
    return savedLocale
  }
  if (['en', 'es', 'fr'].includes(browserLocale)) {
    return browserLocale
  }
  return defaultLocale as SupportedLocale
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    es,
    fr,
  },
})

export const setLocale = (locale: SupportedLocale): void => {
  i18n.global.locale.value = locale
  localStorage.setItem('locale', locale)
  document.documentElement.setAttribute('lang', locale)
}

export const availableLocales: { code: SupportedLocale; name: string }[] = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
]

export default i18n
